import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]
  static values = { hiddenClass: String }

  connect() {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent')
    if (cookieConsent) {
      // User already made a choice, keep banner hidden
      this.bannerTarget.classList.add(this.hiddenClassValue || 'translate-y-full')
    } else {
      // No consent yet, show banner with animation
      this.bannerTarget.classList.remove('hidden')
      // Small delay to ensure CSS transition works
      setTimeout(() => {
        this.bannerTarget.classList.remove(this.hiddenClassValue || 'translate-y-full')
      }, 10)
    }
  }

  acceptAll() {
    this.saveConsent({ essential: true, analytics: true, contact: true })
    this.hideBanner()
  }

  reject() {
    this.saveConsent({ essential: true, analytics: false, contact: false })
    this.hideBanner()
  }

  saveConsent(preferences) {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences))
    // Dispatch custom event for analytics initialization
    window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: preferences }))
  }

  hideBanner() {
    this.bannerTarget.classList.add(this.hiddenClassValue || 'translate-y-full')
  }
}